import type { CreatedSelectFilter } from '../../../../../common/constants/filters/select-filter/types';
import { getSiteCloudId } from '../../../../../common/constants/filters/site';
import { all1pProductKeys, all3pProductKeys } from '../../../../../common/constants/product-keys';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

export const filter: CreatedSelectFilter<'site'> = createMultiSelectFilter<'site'>({
	id: 'site',
	products: [...all1pProductKeys, ...all3pProductKeys],
	alwaysVisible: false,
	universal: true,
	queryParams: {
		key: 'sites',
		fetcher: async (queryParams, config) => {
			return (config.unitMetadata ?? [])
				.map((site) => ({ cloudId: getSiteCloudId(site.id), siteName: site.siteName }))
				.filter(
					({ cloudId }) =>
						cloudId !== config.cloudId && // Excludes the current site (injected as display-only)
						queryParams.includes(cloudId),
				)
				.map(({ cloudId, siteName }) => ({
					trackingKey: cloudId,
					value: cloudId,
					label: siteName,
					queryParamValue: cloudId,
					isSelected: true,
				}));
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			return (config.unitMetadata ?? [])
				.map((site) => ({ cloudId: getSiteCloudId(site.id), siteName: site.siteName }))
				.filter(
					({ cloudId }) => cloudId !== config.cloudId, // Excludes the current site (injected as display-only)
				)
				.map(({ cloudId, siteName }) => ({
					trackingKey: cloudId,
					value: cloudId,
					label: siteName,
					queryParamValue: cloudId,
				}));
		},
	},
});
